export const COMMUNICATION = {
  MESSAGES: 'MESSAGES',
  THREAD: 'THREAD',
};
